var React = require('react');

function Strapi (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","fillRule":"evenodd","clipRule":"evenodd","fill":"#8E75FF","key":0},[React.createElement("path",{"d":"M12.627 12.876V7.704a.333.333 0 0 0-.334-.333H7.128V2.032h10.497a.333.333 0 0 1 .334.334v10.51h-5.332Z","key":0}),React.createElement("path",{"opacity":".405","d":"M7.128 2.032v5.339h-4.93a.167.167 0 0 1-.118-.285l5.048-5.054Zm5.499 15.779v-4.935h5.332l-5.048 5.053a.167.167 0 0 1-.284-.118Zm-5.5-10.44h5.333a.167.167 0 0 1 .167.166v5.339H7.46a.335.335 0 0 1-.333-.334V7.371Z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M2 2h16v16H2z"})))]);
}

Strapi.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Strapi;

Strapi.default = Strapi;
